var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconRestaurantEatingSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9v13.5M20.247 15H22.5a.75.75 0 0 0 .75-.748c.008-3.831.028-8.458-1.559-12.289a.75.75 0 0 0-1.443.287V22.5M.75 1.5v6A1.5 1.5 0 0 0 2.25 9h0a1.5 1.5 0 0 0 1.5-1.5v-6M16.5 8.283a7.173 7.173 0 0 0-9.744-.7M6 18.717a7.178 7.178 0 0 0 10.5 0",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconRestaurantEatingSet);
export default __webpack_public_path__ + "static/media/streamline-icon-restaurant-eating-set.372c074f.svg";
export { ForwardRef as ReactComponent };